const getLanguageById = (id, allLanguages) => allLanguages.find((l) => l.id === id);

export default getLanguageById;
